import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider as ReduxProvider } from "react-redux";
import { persistor, store } from "./store";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { PersistGate } from "redux-persist/integration/react";

// const theme = createTheme();
import theme from "./styles/themeYBS";

ReactDOM.render(
    <React.StrictMode>
        <ReduxProvider store={store}>
            <PersistGate loading={<div>loading</div>} persistor={persistor}>
                <ThemeProvider theme={theme}>
                    <Router>
                        <App />
                    </Router>
                </ThemeProvider>
            </PersistGate>
        </ReduxProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
